export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12029.97e675a7.jpg";